// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { OrderConfirmationPageContext } from "@insite/content-library/Pages/OrderConfirmationPage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

export interface OrderNumberStyles {
    wrapper?: InjectableCss;
    orderNumberHeading?: TypographyPresentationProps;
    orderNumberText?: TypographyPresentationProps;
}

export const orderNumberStyles: OrderNumberStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    orderNumberHeading: {
        size: "inherit",
        weight: "inherit",
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.large};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
            ${contentSpacingStyles(0, 0, "0.5em")}
        `,
    },
    orderNumberText: {
        css: css`
            margin-left: 0.5em;
        `,
    },
};

const styles = orderNumberStyles;

const OrderNumber: FC = () => {
    const cart = useSelector(
        (state: ApplicationState) => getCartState(state, state.pages.orderConfirmation.cartId).value,
    );

    if (!cart) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.orderNumberHeading}>
                {`${translate("Order")} #`}
                <Typography {...styles.orderNumberText} data-test-selector="orderConfirmation_orderNumber">
                    {cart.erpOrderNumber || cart.orderNumber}
                </Typography>
            </Typography>
            <Typography {...styles.orderNumberHeading}>
                {`${translate("Order Date")} `}
                <Typography {...styles.orderNumberText} data-test-selector="orderConfirmation_orderDate">
                    <LocalizedDateTime dateTime={cart.orderDate} />
                </Typography>
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderNumber,
    definition: {
        displayName: "Order Number",
        allowedContexts: [OrderConfirmationPageContext],
        group: "Order Confirmation",
    },
};

export default widgetModule;
